import { Panel } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Trash2, Plus } from "lucide-react";

const CONTACTS = [["hotline", "Hotline"], ["mobile", "Mobile / SMS"], ["email", "Support email"], ["address", "Office address"], ["hours", "Office hours"]];

export function MobileSettings({ mobile, setMobile }) {
  const setSup = (k) => (e) => setMobile({ ...mobile, support: { ...mobile.support, [k]: e.target.value } });
  const setFaq = (i, k, v) => setMobile({ ...mobile, faqs: mobile.faqs.map((f, j) => (j === i ? { ...f, [k]: v } : f)) });
  return (
    <div className="space-y-6">
      <Panel title="Support contacts" description="Shown on the mobile app's Help screen.">
        <div className="grid sm:grid-cols-2 gap-4">{CONTACTS.map(([k, l]) => (
          <div key={k} className="space-y-1.5 min-w-0"><Label htmlFor={`sup-${k}`}>{l}</Label>
            <Input id={`sup-${k}`} value={mobile.support[k] || ""} onChange={setSup(k)} data-testid={`mobile-support-${k}`} /></div>))}</div>
      </Panel>
      <Panel title="Bill estimator and fees" description="The estimator gives consumers a rough figure only; actual bills follow the approved rates.">
        <div className="grid sm:grid-cols-2 gap-4">
          <div className="space-y-1.5"><Label htmlFor="rate">Estimator rate per kWh (PHP)</Label>
            <Input id="rate" inputMode="decimal" value={mobile.estimator_rate_per_kwh} placeholder="12.00"
              onChange={(e) => setMobile({ ...mobile, estimator_rate_per_kwh: e.target.value })} data-testid="mobile-estimator-rate" /></div>
          <div className="space-y-1.5"><Label htmlFor="fee">Online payment convenience fee (PHP)</Label>
            <Input id="fee" inputMode="decimal" value={mobile.convenience_fee} placeholder="0.00"
              onChange={(e) => setMobile({ ...mobile, convenience_fee: e.target.value })} data-testid="mobile-convenience-fee" /></div>
          <div className="space-y-1.5 sm:col-span-2"><Label htmlFor="note">Estimator note</Label>
            <Input id="note" value={mobile.estimator_rate_note} onChange={(e) => setMobile({ ...mobile, estimator_rate_note: e.target.value })} data-testid="mobile-estimator-note" /></div>
        </div>
        <p className="text-xs text-slate-500 mt-2">Use two decimals, for example 12.00.</p>
      </Panel>
      <Panel title="Frequently asked questions" actions={
        <Button size="sm" variant="outline" onClick={() => setMobile({ ...mobile, faqs: [...mobile.faqs, { q: "", a: "" }] })} data-testid="mobile-faq-add"><Plus className="h-4 w-4 mr-1" />Add question</Button>}>
        {mobile.faqs.length === 0 && <p className="text-sm text-slate-500">No questions yet.</p>}
        <div className="space-y-4">{mobile.faqs.map((f, i) => (
          <div key={i} className="border border-slate-200 rounded-md p-3 space-y-2" data-testid={`mobile-faq-${i}`}>
            <div className="flex gap-2"><Input placeholder="Question" value={f.q} onChange={(e) => setFaq(i, "q", e.target.value)} data-testid={`mobile-faq-q-${i}`} />
              <Button size="icon" variant="ghost" onClick={() => setMobile({ ...mobile, faqs: mobile.faqs.filter((_, j) => j !== i) })} data-testid={`mobile-faq-remove-${i}`}><Trash2 className="h-4 w-4" /></Button></div>
            <Textarea rows={2} placeholder="Answer" value={f.a} onChange={(e) => setFaq(i, "a", e.target.value)} data-testid={`mobile-faq-a-${i}`} />
          </div>))}</div>
      </Panel>
    </div>
  );
}
